<template>
  <div class="booking-plan">
    <div class="booking-plan-header">
      <van-icon
        name="arrow-left"
        :color="currentMonth.index === 0 ? 'rgba(4, 0, 0, 0.5)' : '#040000'"
        @click="changeMonth('preview')"
      />
      <span>
        {{ currentMonth.year }}年，{{ currentMonth.month }}月
      </span>
      <van-icon
        name="arrow"
        :color="currentMonth.isLast ? 'rgba(4, 0, 0, 0.5)' : '#040000'"
        @click="changeMonth('next')"
      />
    </div>
    <div class="booking-plan-date">
      <div
        class="booking-plan-date-item"
        :class="{
            'booking-plan-date-item-current': item.select
        }"
        v-for="item in dataList"
        :key="item.fullDate"
        @click="changeDate(item)"
      >
        <div class="booking-plan-date-item-week">
          {{ item.day }}
        </div>
        <div class="booking-plan-date-item-day">
          {{ item.date }}
        </div>
      </div>
    </div>
    <div class="booking-division" />

    <div class="booking-plan-list">
      <div
        class="booking-plan-item"
        v-for="(item, index) in currentPlan"
        :key="index"
        :class="{
            'booking-plan-item-disabled': !item['预约号数']
        }"
      >
        <div class="booking-plan-item-left">
          <div class="booking-plan-item-left-column">
            <div>
              {{ moment(item['预约日期']).format('MM-DD') }}
            </div>
            <div>
              圆和医疗
            </div>
          </div>
          <div class="booking-plan-item-left-column">
            <div>
              {{ item['开始时间'] }}-{{ item['截止时间'] }}
            </div>
            <div>
              余号{{ item['预约号数'] }}
            </div>
          </div>
        </div>
        <div
          v-if="item['预约号数']"
          class="booking-plan-item-right"
          @click="confirm(item)"
        >
          预约
        </div>
        <div
          v-else
          class="booking-plan-item-right booking-plan-item-right-reason"
          @click="showReason(item)"
        >
          查看原因
        </div>
      </div>

    </div>
    <div
      class="booking-plan-noData"
      v-show="currentPlan.length === 0"
    >
      当前暂无排班
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import moment from "moment";
import bookingService from "@/apis/booking";
import { Toast } from "vant";
import enums from "@/views/booking/mixins/enums";

let currentDate = moment().add(1, "days").format("YYYY-MM-DD");
const dayList = ["日", "一", "二", "三", "四", "五", "六"];

export default {
  mixins: [enums],

  data() {
    return {
      dataList: [],
      planMap: {},
      currentPlan: [],
      selectPlan: null,
      currentDate,
      monthMap: {},
      currentMonth: {},
      packageInfo: {},
    };
  },
  components: {},
  async created() {
    await this.hisPackageSearch();
    const { packageInfo } = this;
    if (packageInfo.neijingItemID) {
      this.currentDate = moment(currentDate)
        .add(2, "days")
        .format("YYYY-MM-DD");
      // currentDate = this.currentDate;
    }
    if (packageInfo.waiSongItemID) {
      this.currentDate = moment(currentDate)
        .add(2, "days")
        .format("YYYY-MM-DD");
    }
    this.initDate();
    this.hisPlanSearch();
  },
  methods: {
    moment,
    modifyAppointment() {
      const query = this.$route.query;
      const { selectPlan, currentUserInfo } = this;
      const params = {
        ...query,
        his_booking_time: selectPlan["预约日期"],
        his_booking_begintime: selectPlan["开始时间"],
        his_booking_endtime: selectPlan["截止时间"],
        his_booking_planid: selectPlan["体检人次ID"],
        his_booking_tijian_planid: selectPlan["体检人次ID"],
        his_booking_neijing_planid: selectPlan["内镜人次ID"],
        SubmitUserId: currentUserInfo.user_id,
        SubmitUser: currentUserInfo.user_name,
      };
      bookingService.bookReservationEdit(params).then((res) => {
        Toast("改约成功");
        this.$router.go(-1);
        console.log(res);
      });
    },
    hisPackageSearch() {
      const query = this.$route.query;

      const params = {
        tcID: query.his_package_id,
        tcName: ``,
        pageNo: 1,
        pageSize: 9999,
        companyID: 0,
      };
      return bookingService
        .hisPackageSearch(params)
        .then((res) => {
          this.packageInfo = res[0] || {};
          if (query.his_package_id < -1) {
            this.packageInfo = {
              neijingItemID: "dsafdasf",
            };
          }
        })
        .catch(() => {
          this.packageInfo = {};
        });
    },
    showReason(item) {
      const reasonList = [];
      if (item["体检人次ID"] && item["剩余号数A"] == "0") {
        reasonList.push("体检余号为0");
      }
      if (item["内镜人次ID"] && item["剩余号数B"] == "0") {
        reasonList.push("内镜余号为0");
      }
      if (item["磁共振人次ID"] && item["剩余号数C"] == "0") {
        reasonList.push("外送余号为0");
      }
      Toast(reasonList.join("，"));
    },
    confirm(item) {
      const { query } = this.$route;
      if (query.apply_id) {
        this.selectPlan = item;
        this.modifyAppointment();
      } else {
        this.$store.dispatch("booking/setPlanInfo", item);
        this.$router.go(-1);
      }
    },
    hisPlanSearch() {
      const query = this.$route.query;
      const packageInfo = this.packageInfo;
      const idlist = [];
      let itemId = "";
      if (packageInfo.neijingItemID) {
        idlist.push("13");
      }
      if (packageInfo.waiSongItemID) {
        idlist.push("46");
      }

      // 体检特殊套餐
      if (
        query.his_package_id != -2 &&
        query.his_package_id != 0 &&
        query.his_package_id != -3 &&
        query.his_package_id != -4
      ) {
        itemId = "5466";
      } else if (
        query.his_package_id == "-2" ||
        query.his_package_id == "-3" ||
        query.his_package_id == "-4"
      ) {
        itemId = "5473";
      }
      const params = {
        itemId,
        idlist: idlist.join(","),
        packageId: query.his_package_id,
      };
      const loading = this.$loading({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      bookingService
        .hisPlanSearch(params)
        .then((res) => {
          const planMap = {};
          res.forEach((item) => {
            const date = moment(item["预约日期"]).format("YYYY-MM-DD");

            if (!planMap[date]) planMap[date] = [];
            planMap[date].push(item);
          });
          this.currentPlan = planMap[this.currentDate] || [];
          this.planMap = planMap;
          loading.close();
        })
        .catch(() => {
          loading.close();
        });
    },
    changeDate(dateInfo) {
      const { planMap, dataList } = this;
      dataList.forEach((item) => (item.select = false));
      dateInfo.select = true;
      this.currentDate = dateInfo.fullDate;
      this.dataList = [...dataList];
      this.currentPlan = planMap[dateInfo.fullDate] || [];
    },
    initDate() {
      const duration = 30;
      const dataList = [];
      const monthMap = {};
      for (let i = 0; i < duration; i++) {
        const date = moment(this.currentDate).add(i, "days");
        const month = moment(date).format("YYYY-MM");

        if (!monthMap[month]) {
          monthMap[month] = {
            year: moment(date).year(),
            month: moment(date).month() + 1,
            dateList: [],
          };
        }

        const dateInfo = {
          fullDate: moment(date).format("YYYY-MM-DD"),
          date: moment(date).date(),
          day: dayList[moment(date).day()],
          select: i === 0,
        };
        dataList.push(dateInfo);
        monthMap[month].dateList.push(dateInfo);
      }
      Object.keys(monthMap).forEach((key, index) => {
        monthMap[key].index = index;
        if (index === Object.keys(monthMap).length - 1) {
          monthMap[key].isLast = true;
        }
      });
      this.monthMap = monthMap;
      this.currentMonth = {
        index: -1,
      };
      this.changeMonth("next");
      // this.dataList = this.currentMonth.dateList;
    },
    changeMonth(type) {
      const { currentMonth, monthMap } = this;
      if (
        (currentMonth.index === 0 && type === "preview") ||
        (currentMonth.isLast && type === "next")
      ) {
        return;
      }

      let count = 0;
      if (type === "next") {
        count = 1;
      } else {
        count = -1;
      }
      this.currentMonth =
        monthMap[Object.keys(monthMap)[currentMonth.index + count]];
      this.dataList = this.currentMonth.dateList;
      this.changeDate(this.dataList[0]);
    },
  },
};
</script>

<style scoped lang="scss">
.booking-plan {
}
.booking-plan-header {
  text-align: center;
  padding: 15px 20px;
  font-size: 17px;
  i {
    cursor: pointer;
  }
}
.booking-plan-date {
  display: flex;
  padding: 20px 0;
  width: 100%;
  overflow-x: scroll;
}
.booking-plan-date-item {
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
  .booking-plan-date-item-week {
    color: rgba(4, 0, 0, 0.5);
    text-align: center;
  }
  .booking-plan-date-item-day {
    margin-top: 20px;
    border-radius: 50px;
    height: 26px;
    width: 26px;
    display: flex;
    justify-content: center;
    align-items: center;

    font-size: 17px;
  }
}
.booking-plan-date-item-current {
  .booking-plan-date-item-day {
    background: #da0032;

    color: #eaeaea;
  }
}
.booking-plan-list {
}
.booking-plan-item {
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .booking-plan-item-left {
    display: flex;
  }
  .booking-plan-item-left-column {
    margin-right: 30px;
    div:nth-child(2) {
      margin-top: 10px;
    }
  }
  .booking-plan-item-right {
    color: #da0032;
    cursor: pointer;
  }
  .booking-plan-item-right-reason {
    color: rgba(4, 0, 0, 0.5);
  }
}

.booking-plan-item-disabled {
  color: rgba(4, 0, 0, 0.5);
}
.booking-plan-noData {
  text-align: center;
  margin-top: 30%;
  color: rgba(4, 0, 0, 0.5);
  font-size: 15px;
}
</style>
